module.exports = __webpack_public_path__ + "static/media/ic_pin_blanco.5fa59372.webp";


//////////////////
// WEBPACK FOOTER
// ./assets/img/ic_pin_blanco.webp
// module id = 106
// module chunks = 1